import { render, staticRenderFns } from "./gj-explain-alert.vue?vue&type=template&id=739458c2&scoped=true&"
import script from "./gj-explain-alert.vue?vue&type=script&lang=js&"
export * from "./gj-explain-alert.vue?vue&type=script&lang=js&"
import style0 from "./gj-explain-alert.vue?vue&type=style&index=0&id=739458c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739458c2",
  null
  
)

export default component.exports